module.exports = __webpack_public_path__ + "img/рз_40.fcf93332.png";